import { render, staticRenderFns } from "./SMKDetails.vue?vue&type=template&id=75551324&scoped=true&"
import script from "./SMKDetails.vue?vue&type=script&lang=js&"
export * from "./SMKDetails.vue?vue&type=script&lang=js&"
import style0 from "./SMKDetails.vue?vue&type=style&index=0&id=75551324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75551324",
  null
  
)

export default component.exports